interface RewardsQueryEligibilityArgs {
  participantExists: boolean | undefined;
  showProfile: boolean;
  activeTab: string;
}

export interface RewardsQueryEligibility {
  board: boolean;
  content: boolean;
  ladder: boolean;
  milestones: boolean;
  quests: boolean;
  referrals: boolean;
  streak: boolean;
}

/** Keep participant data idle until the view that owns it can render. */
export function getRewardsQueryEligibility({
  participantExists,
  showProfile,
  activeTab,
}: RewardsQueryEligibilityArgs): RewardsQueryEligibility {
  const participant = participantExists === true;
  const dashboard = participant && !showProfile;

  return {
    board: dashboard && activeTab === 'leaderboard',
    content: participant,
    ladder: dashboard,
    milestones: dashboard && activeTab === 'milestones',
    quests: dashboard,
    referrals: participant,
    streak: dashboard,
  };
}
